import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import ReactInputMask from "react-input-mask";
import DatePicker from "react-datepicker";

function EditCouponDetails(props) {

  const location = useLocation();
  const navigate = useNavigate();

  const { couponId } = location.state;

  const token = GetStorage.get("xAuthToken");

  useEffect(() => {

    if (couponId) {
      getCouponDetails();
    }
  }, []);

  const [error, setError] = useState("");
  const [couponDetails, setCouponDetails] = useState({});

  const getCouponDetails = () => {
    http
      .get(`api/admin/coupon/${couponId}?token=${token}`)
      .then((res) => {
        let getDetailsOfCoupon = res.data[0];
        getDetailsOfCoupon.discount = parseFloat(getDetailsOfCoupon.discount).toFixed(2);

      setCouponDetails(getDetailsOfCoupon);
        setCouponDetails(res.data[0]);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  


  const onSubmit = async (values) => {
    if (couponDetails.id) {
      http
        .put(`api/admin/edit-coupon?token=${token}`, {
          id: couponDetails.id,
          coupon_code: couponDetails.coupon_code,
          discount: couponDetails.discount != undefined && couponDetails.discount != '' ? parseFloat(couponDetails.discount).toFixed(2) : '',
          expiration_date: couponDetails.expiration_date,
        })
        .then((res) => {
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });

    } else {
      http
        .post(`api/admin/create-coupon?token=${token}`, {
            id: couponDetails.id,
            coupon_code: couponDetails.coupon_code,
            discount: couponDetails.discount != undefined && couponDetails.discount != '' ? parseFloat(couponDetails.discount).toFixed(2) : '',
            expiration_date: couponDetails.expiration_date,
        })
        .then((res) => {
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });
    }

  };

  const onChangeProp = (event, key) => {
    couponDetails[key] = event.target.value
    setCouponDetails(couponDetails);
  };

  const handleDateChange = (date) => {
    const currentTime = new Date();
    date.setHours(currentTime.getHours());
    date.setMinutes(currentTime.getMinutes());
    date.setSeconds(currentTime.getSeconds());
    setCouponDetails((prevDetails) => ({
      ...prevDetails,
      expiration_date: date,
    }));
  };


  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>{couponId != null && couponId != undefined  ? "Edit Coupon Details" : "Add Coupon Details" }</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>

            <Formik
              initialValues={couponDetails}
              onSubmit={onSubmit}>
              {({ values, handleSubmit, setFieldValue, handleChange }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add mt-5">
                      {/* <h5 className="my-3">General Info</h5> */}
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Coupon</label>
                              <input
                                type="text"
                                id="coupon_code"
                                name="coupon_code"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "coupon_code")
                                }}
                                value={couponDetails.coupon_code}
                                placeholder="Enter Coupon Code"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Discount(%)</label>
                              <input
                                type="text"
                                id="discount"
                                name="discount"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "discount")
                                }}
                                value={couponDetails.discount}
                                placeholder="Enter discount"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group lease_date">
                              <label>Expiration Date</label>

                              <DatePicker
                                selected={couponDetails.expiration_date}
                                className="custom_input form-control"
                                onChange={handleDateChange}
                                minDate={new Date()}
                                placeholderText="Select Expiration Date"
                              />
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <button
                                onClick={() => navigate(-1)}
                                type="button"
                                className=" them_btn_ouline  "
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="them_btn "
                                onClick={onSubmit}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}

export default EditCouponDetails;
